import styled from "styled-components";
const DenylistPageDisplay = styled.div`
	// my css here
`;	export default DenylistPageDisplay;
